module.exports = __webpack_public_path__ + "img/logo_white.4bcf219d.png";